import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.563 6.563H3.438a.92.92 0 01-.938-.938.92.92 0 01.938-.938h13.124a.92.92 0 01.938.938.92.92 0 01-.938.938zm0 4.375H3.438A.92.92 0 012.5 10a.92.92 0 01.938-.938h13.124A.92.92 0 0117.5 10a.92.92 0 01-.938.938zm0 4.374H3.438a.92.92 0 01-.938-.937.92.92 0 01.938-.938h13.124a.92.92 0 01.938.938.92.92 0 01-.938.938z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
